export default {
    brush: {
        title: 'Borste',
        brushHardness: 'Penselhårdhet',
        brushSize: 'Penselstorlek',
        brushColor: 'Penselfärg',
    },
};
